var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchIcon = function SvgSearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#213D38",
    fillOpacity: 0.32,
    d: "m12.253 13.36-.502-.488.975-1.005.502.488zm4.901 2.804.502.488-.975 1.004-.502-.487zm-2.988-1.923.488-.503zM4.034 8.763c0 2.592 2.172 4.729 4.895 4.729v1.4c-3.456 0-6.295-2.725-6.295-6.13zm4.895 4.729c2.724 0 4.895-2.137 4.895-4.73h1.4c0 3.405-2.838 6.13-6.295 6.13zm4.895-4.73c0-2.592-2.171-4.729-4.895-4.729v-1.4c3.457 0 6.295 2.725 6.295 6.13zM8.928 4.034c-2.723 0-4.895 2.137-4.895 4.73h-1.4c0-3.405 2.839-6.13 6.295-6.13zm4.3 8.322 1.426 1.383-.975 1.005-1.426-1.384zm1.426 1.383 2.5 2.426-.975 1.005-2.5-2.426z"
  })));
};
export default SvgSearchIcon;